import axios from 'axios';

import parseCheckoutResponseFactory from '../utils/parse-checkout-response';
import checkoutFragment from './checkout.fragment';
import { submitSentryError } from '../providers/error-boundary';
import { BACKEND_URL } from '../config';

const UPDATE_ITEM_CHECKOUT_QUERY = `
  mutation checkoutLineItemsUpdate($checkoutId: ID!, $lineItems: [CheckoutLineItemUpdateInput!]!) {
    checkoutLineItemsUpdate(checkoutId: $checkoutId, lineItems: $lineItems) {
      checkout {
        ...cart
      }
      userErrors {
        message
        field
      }
    }
  }

  ${checkoutFragment}
`

const updateLineItem = ({ id }, quantity, checkoutId, setCart) => {

    if (id.includes('__')) {
        id = id.split('__').pop();
    }

    const variables = {
        lineItems: [
            {
                id,
                quantity
            }
        ],
        checkoutId
    }

    const payload = {
        query: UPDATE_ITEM_CHECKOUT_QUERY,
        variables
    }

    let headers = {
        "Content-Type": 'application/json'
    }

    const parseCheckoutResponse = parseCheckoutResponseFactory('checkoutLineItemsUpdate');

    return axios.post(BACKEND_URL, payload, { headers })
        .then(parseCheckoutResponse)
        .then((result) => setCart(result))
        .catch((error) => submitSentryError(error, { tag: { api: 'Shopify', action: 'updateLineItem' } }));

}

export default updateLineItem;